import React, { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function PosCartPage() {
  const [searchParams] = useSearchParams();
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);

  const path = useMemo(() => {
    const qs = searchParams.toString();
    return `/pos/cart${qs ? `?${qs}` : ''}`;
  }, [searchParams]);

  const loadPage = async () => {
    setLoading(true);
    try {
      const res = await fetch(path, { credentials: 'same-origin', cache: 'no-store' });
      const text = await res.text();
      setHtml(text);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPage();
  }, [path]);

  useEffect(() => {
    if (!html) return;

    try { window.parent.postMessage({ type: 'refresh' }, '*'); } catch (_) {}

    const root = document.getElementById('pos-cart-root');
    if (!root) return;

    const postAction = async (action, productId = null) => {
      const fd = new FormData();
      fd.append('action', action);
      if (productId !== null) fd.append('product_id', String(productId));

      let res; let text = ''; let data;
      try {
        res = await fetch(path, { method: 'POST', body: fd, credentials: 'same-origin' });
        text = await res.text();
        data = JSON.parse(text);
      } catch (e) {
        alert('AJAX 실패 또는 JSON 파싱 실패:\n' + (text || e.message));
        return false;
      }

      if (!data.success) {
        alert(data.message || '처리 실패');
        return false;
      }
      try { window.parent.postMessage({ type: 'refresh' }, '*'); } catch (_) {}
      await loadPage();
      return true;
    };

    const onAct = (e) => {
      const btn = e.currentTarget;
      e.preventDefault();
      const act = btn.dataset.act;
      const pid = btn.dataset.pid ? parseInt(btn.dataset.pid, 10) : null;
      postAction(act, pid);
    };

    root.querySelectorAll('[data-act]').forEach((btn) => btn.addEventListener('click', onAct));

    const btnClear = root.querySelector('#btnClear');
    const onClear = (e) => {
      e.preventDefault();
      if (!window.confirm('장바구니를 전부 비울까요?')) return;
      postAction('clear');
    };
    btnClear?.addEventListener('click', onClear);

    const btnPlaceOrder = root.querySelector('#btnPlaceOrder');
    const onPlaceOrder = async (e) => {
      e.preventDefault();
      if (!btnPlaceOrder || btnPlaceOrder.classList.contains('disabled')) return;
      if (!window.confirm('주문을 전송할까요?\n결제는 나갈 때 카운터에서 진행합니다.')) return;

      btnPlaceOrder.disabled = true;
      const oldText = btnPlaceOrder.innerText;
      btnPlaceOrder.innerText = '전송중...';

      let res; let text = ''; let data;
      try {
        res = await fetch('/api/pos/table-place-order', { method: 'POST', credentials: 'same-origin' });
        text = await res.text();
        data = JSON.parse(text);
      } catch (err) {
        alert('주문 전송 실패(서버응답 확인):\n' + (text || err.message));
        btnPlaceOrder.disabled = false;
        btnPlaceOrder.innerText = oldText;
        return;
      }

      if (!data.success) {
        alert(data.message || '주문 전송 실패');
        btnPlaceOrder.disabled = false;
        btnPlaceOrder.innerText = oldText;
        return;
      }

      alert('주문이 전송되었습니다!');
      const tableId = parseInt(searchParams.get('table_id') || '0', 10);
      try {
        window.parent.postMessage({ type: 'refresh' }, '*');
        setTimeout(() => {
          window.parent.postMessage({ type: 'openDetail', table_id: tableId }, '*');
        }, 150);
      } catch (_) {}

      await loadPage();
    };
    btnPlaceOrder?.addEventListener('click', onPlaceOrder);

    return () => {
      root.querySelectorAll('[data-act]').forEach((btn) => btn.removeEventListener('click', onAct));
      btnClear?.removeEventListener('click', onClear);
      btnPlaceOrder?.removeEventListener('click', onPlaceOrder);
    };
  }, [html, path, searchParams]);

  if (loading) return <div className="p-3">로딩 중...</div>;
  return <div id="pos-cart-root" dangerouslySetInnerHTML={{ __html: html }} />;
}
